export * from './async';
export * from './settings';

import { settingsSlice } from './slice';

const Reducer = settingsSlice.reducer;
const Actions = settingsSlice.actions;

export { Reducer, Actions };
